import { render, staticRenderFns } from "./trainingSetupList.vue?vue&type=template&id=1a510676&scoped=true&"
import script from "./trainingSetupList.vue?vue&type=script&lang=js&"
export * from "./trainingSetupList.vue?vue&type=script&lang=js&"
import style0 from "./trainingSetupList.vue?vue&type=style&index=0&id=1a510676&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a510676",
  null
  
)

export default component.exports